// extracted by mini-css-extract-plugin
module.exports = {"cat_single_card":"DetailCard_cat_single_card__3iWzC"};